// extracted by mini-css-extract-plugin
export default {"link":"_1LNTF","timeAgo":"_2BQ0D","avatar":"VoKBz","directionIcon":"_3sSJI","text":"_3MSay"};